import { ISendNotificationParams } from '~/utils/interface/notification';
import axiosClient from './axiosClient';
import { ITransferDistributor } from '~/utils/interface/account';
import { IAlert } from '~/utils/interface/alert';

const url: string = '/api/notification';

const notificationApi = {
  listAlert() {
    return axiosClient.get<Array<IAlert>>(url + '/list-alert');
  },
  send(data: ISendNotificationParams) {
    return axiosClient.post<string>(`/api/notification/due-device`, data);
  },
  transferDistributor(data: ITransferDistributor) {
    return axiosClient.post<string>(url + '/transfer-distributor?username=' + data.username);
  },
};

export default notificationApi;
